import { setSelectedActivity, setSplitPanelOpen } from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";
import { ActivityItem } from "../../components/activity-log/definitions";

export const useActivityLogSplitPanel = () => {
  const dispatch = useAppDispatch();
  const splitPanel = useAppSelector((state) => state.activityLogSplitPanel);

  return {
    splitPanel,
    setSelectedActivity: (payload: ActivityItem | null) => {
      dispatch(setSelectedActivity(payload));
    },
    setSplitPanelOpen: (payload: boolean) => {
      dispatch(setSplitPanelOpen(payload));
    },
  };
};
